"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyleSet;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _AdaptiveCardRenderer = _interopRequireDefault(require("./StyleSet/AdaptiveCardRenderer"));

var _AnimationCardAttachment = _interopRequireDefault(require("./StyleSet/AnimationCardAttachment"));

var _AudioCardAttachment = _interopRequireDefault(require("./StyleSet/AudioCardAttachment")); // TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.


function createStyleSet(options) {
  options = (0, _objectSpread2.default)({}, _botframeworkWebchatComponent.defaultStyleOptions, options);
  var basicStyleSet = (0, _botframeworkWebchatComponent.createStyleSet)(options); // Keep this list flat (no nested style) and serializable (no functions)

  return (0, _objectSpread2.default)({}, basicStyleSet, {
    adaptiveCardRenderer: (0, _AdaptiveCardRenderer.default)(options),
    animationCardAttachment: (0, _AnimationCardAttachment.default)(options),
    audioCardAttachment: (0, _AudioCardAttachment.default)(options)
  });
}